export enum EquipmentEnum {
    ATHLETIC_ATTIRE = 'athleticAttire',
    ATHLETIC_ATTIRE_AND_SHOES = 'athleticAttireAndShoes',
    WIND_PROTECTING_LAYER = 'windProtectingLayer',
    LEISURE_WEAR = 'leisureWear',
    SMALL_BACKBACK = 'smallBackpack',
    TREKKING_SHOES = 'trekkingShoes',
    SWIMSUIT = 'swimsuit',
    SUN_PROTECTION_GEAR = 'sunProtectionGear',
    TENNIS_ATTIRE = 'tennisAttire',
    GOLF_ATTIRE = 'golfAttire',
    LIGHT_SWEATER_OR_FLEECE = 'lightSweaterOrFleece',
}
